import { render, staticRenderFns } from "./ImportCustomerView.vue?vue&type=template&id=37a7a6ac"
import script from "./ImportCustomerView.vue?vue&type=script&lang=js"
export * from "./ImportCustomerView.vue?vue&type=script&lang=js"
import style0 from "./ImportCustomerView.vue?vue&type=style&index=0&id=37a7a6ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports